import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
function InfoText({ text }) {
    return _jsx("div", { className: "info-text", children: text });
}
InfoText.propTypes = {
    text: PropTypes.string.isRequired,
};
export default InfoText;
